import {modelOptions} from "../../Components/Top/MiddleComponent/Models/ModelsDropdown/ModelsDropdown.tsx";
import modelProviderMapping from "../IdMappings/modelProviderMapping.ts";
import {DEFAULT_MODEL} from "../../Globals.ts";

export const canSeeVideo = (model: string) => {
    return model === "Automatic" || model.includes("Gemini");
}

export const canSeeImage = (model: string) => {
    return model === "Automatic" || model.includes("Gemini") || model.includes("Claude") || model.includes("GPT") || model === "Grok";
}

export const canHearAudio = (model: string) => {
    return model === "Automatic" || model.includes("Gemini");
}

export const isModelPremium = (modelName: string): boolean => {
    for (const provider of modelOptions) {
        const model = provider.models.find((m: any) => m.name === modelName);
        if (model) {
            return model.isPremium;
        }
    }
    return false;
}

export const validateModelExists = (model: string): string => {
    return modelProviderMapping[model] ? model : DEFAULT_MODEL;
};